import { put, takeLatest } from "redux-saga/effects";
import { getListGameApi } from "store/api/GameApi";
import { GET_LIST_GAME_ACTION } from "../../actions/GamePageAction/actionTypes";

import * as gamePageAction from "../../actions/GamePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* getListGame() {
	yield put(globalAction.openLoadingPage());
	const res = yield getListGameApi();
	try {
		yield put(gamePageAction.setListGameAction(res?.games));
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getListGameSaga() {
	yield takeLatest(GET_LIST_GAME_ACTION, getListGame);
}

export default getListGameSaga;
